import 'react-phone-input-2/lib/style.css';
import { EditText } from '../edit-text/edit-text';
import React, { useEffect, useState } from 'react';
import { createUserOperation } from './operations/create-user-operation';
import { Calendar } from 'primereact/calendar';
import { AddUserDialogSelectUserType } from './componenets/add-user-dialog-select-user-type';
import { UserType } from '../../../api/types/user/user-type';
import { Button } from 'primereact/button';
import { fetchCitiesOperations } from './operations/fetch-cities-operations';
import { AutoComplete } from 'primereact/autocomplete';
import { EditNumber } from '../edit-text/edit-number';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { fetchCountriesOperation } from './operations/fetch-countries-operation';
import {
  Gender,
  MaritalStatus,
  UserSummaryType,
} from '../../../api/types/user/user-summary.type';
import { UpdateAvatarFileDialog } from '../search-users/compoenents/update-avatar-file-dialog/update-avatar-file-dialog';
import { Avatar } from 'primereact/avatar';
import { FileUploadFile } from 'primereact/fileupload';
import globalSettingsBranches from '../../../stores/global-settings-branches';

interface AddUserDialogDataModel {
  onHide: () => any;
  role?: UserType;
  onUserCreated?: (user: UserSummaryType) => void;
}
export const AddUserDialog: React.FC<AddUserDialogDataModel> = ({
  onHide,
  role,
  onUserCreated,
}) => {
  const [cities, setCities] = useState<string[]>([]);
  const [filteredCities, setFilteredCities] = useState<string[]>([]);

  const [loading2, setLoading2] = useState<boolean>(false);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [nationalId, setNationalId] = useState('');
  const [address, setAddress] = useState('');
  const [mail, setMail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [additionalPhoneNumber, setAdditionalPhoneNumber] = useState(null);
  const [date, setDate] = useState<Date | null>(null);
  const [immigrationDate, setImmigrationDate] = useState<Date | null>(null);
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState(role);

  useEffect(() => {
    console.log('asd ' + date);
  }, [date]);

  const handleDateChange = (e: any) => {
    if (e.target.value instanceof Date || e.target.value === null) {
      setDate(e.target.value);
    }
  };

  const handleImmigrationDateDateChange = (e: any) => {
    if (e.target.value instanceof Date || e.target.value === null) {
      setImmigrationDate(e.target.value);
    }
  };

  const [countries, setCountries] = useState<string[]>([]);
  const [filteredCountries, setFilteredCountries] = useState<string[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);

  useEffect(() => {
    fetchCitiesOperations(setCities);
    fetchCountriesOperation(setCountries);
  }, []);

  // Filter method for the autocomplete
  const searchCities = (event: { query: string }) => {
    // Filter the cities that start with the query
    const filtered = cities.filter((city) =>
      city.toLowerCase().startsWith(event.query.toLowerCase()),
    );
    setFilteredCities(filtered);
  };

  // Filter method for the autocomplete
  const searchCountries = (event: { query: string }) => {
    // Filter the cities that start with the query
    const filtered = countries.filter((country) =>
      country.toLowerCase().startsWith(event.query.toLowerCase()),
    );
    setFilteredCountries(filtered);
  };

  // Handle selection
  const handleSelect = (e: { value: string }) => {
    setSelectedCity(e.value);
  };

  const updatePhoneNumber = (value: string) => {
    // Remove all non-digit characters
    const digitsOnly = value.replace(/\D/g, '');

    // Ensure it starts with '05' and limit to 10 digits
    let formatted = '';

    if (digitsOnly.length > 0) {
      // Ensure the number starts with '05'
      if (!digitsOnly.startsWith('05') && digitsOnly.length >= 2) {
        formatted = '05' + digitsOnly.substring(0, 8);
      } else {
        formatted = digitsOnly.substring(0, 10);
      }

      // Add the hyphen after the third digit if we have more than 3 digits
      if (formatted.length > 3) {
        formatted = formatted.substring(0, 3) + '-' + formatted.substring(3);
      }
    }

    setPhoneNumber(formatted);
  };

  const updateAdditionalPhoneNumber = (value: string) => {
    // Remove all non-digit characters
    const digitsOnly = value.replace(/\D/g, '');

    // Ensure it starts with '05' and limit to 10 digits
    let formatted = '';

    if (digitsOnly.length > 0) {
      // Ensure the number starts with '05'
      if (!digitsOnly.startsWith('05') && digitsOnly.length >= 2) {
        formatted = '05' + digitsOnly.substring(0, 8);
      } else {
        formatted = digitsOnly.substring(0, 10);
      }

      // Add the hyphen after the third digit if we have more than 3 digits
      if (formatted.length > 3) {
        formatted = formatted.substring(0, 3) + '-' + formatted.substring(3);
      }
    }

    setAdditionalPhoneNumber(formatted);
  };

  const [addAvatar, setAddAvatar] = useState(false);
  const [selectedUser, setSelectedUser] = useState<
    UserSummaryType | undefined
  >();

  const [uploadedFile, setUploadedFile] = useState<FileUploadFile>();

  const handleUploadedFile = (file: FileUploadFile) => {
    setUploadedFile(file);
  };

  const handleOnSubmit = async () => {
    await createUserOperation(
      uploadedFile,
      firstName,
      lastName,
      nationalId,
      phoneNumber,
      additionalPhoneNumber,
      mail,
      date,
      userType,
      selectedCity,
      street,
      houseNumber,
      flatNumber,
      postCode,

      selectedGender,
      selectedCountry,
      immigrationDate,
      selectedMartialStatus,

      userType === UserType.STUDENT ? selectedBranchIds : null,

      setLoading,
      onHide,
      onUserCreated,
    );
  };

  const [selectedCity, setSelectedCity] = useState<string | null>(null);
  const [street, setStreet] = useState('');
  const [houseNumber, setHouseNumber] = useState('');
  const [flatNumber, setFlatNumber] = useState('');
  const [postCode, setPostCode] = useState('');

  const handleCityChange = (e: { value: string | null }) => {
    setSelectedCity(e.value);
  };

  const genderOptions = [
    { label: 'זכר', value: Gender.Male },
    { label: 'נקבה', value: Gender.Female },
  ];

  const [selectedGender, setSelectedGender] = useState(null);

  const onGenderChange = (e) => {
    setSelectedGender(e.value);
  };

  const martialStatusOptions = [
    { label: 'נשוי', value: MaritalStatus.Married },
    { label: 'רווק', value: MaritalStatus.Single },
    { label: 'גרוש', value: MaritalStatus.Divorced },
    { label: 'אלמן', value: MaritalStatus.Widowed },
  ];

  const [selectedMartialStatus, setSelectedMartialStatus] = useState(null);

  const onMartialStatusChange = (e) => {
    setSelectedMartialStatus(e.value);
  };

  // Branch selection for students
  const [selectedBranchIds, setSelectedBranchIds] = useState<number[]>([]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          paddingTop: '16px',
          gap: '16px', // Space between items
          justifyContent: 'flex-start',
          marginBottom: '16px',
        }}
      >
        <UpdateAvatarFileDialog
          shouldUploadFile={false}
          userId={selectedUser?.id}
          addAvatar={addAvatar}
          setAddAvatar={setAddAvatar}
          setSelectedUser={setSelectedUser}
          setFile={(file: FileUploadFile) => {
            setUploadedFile(file);
            setAddAvatar(false);
          }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Avatar
            style={{ height: '100px', width: '100px' }}
            image={uploadedFile ? URL.createObjectURL(uploadedFile) : ''}
            onClick={() => setAddAvatar(true)}
            label={'תמונה'}
            size="xlarge"
            shape="circle"
          />
          <label style={{ fontSize: '12px', color: '#6b7280' }}>
            תמונה (אופציונלי)
          </label>
        </div>
        <label style={{ fontSize: '12px', color: '#4b5563' }}>
          הזן את הפרטים
        </label>
        <EditText title={'שם פרטי'} onChange={setFirstName} />
        <EditText title={'שם משפחה'} onChange={setLastName} />
        <EditText maxLength={9} title={'ת.ז'} onChange={setNationalId} />
        <EditText title={'רחוב (אופציונלי)'} onChange={setStreet} />
        <EditNumber
          title={'מספר (אופציונלי)'}
          onChange={(value: number) => setHouseNumber(value.toString())}
          showButtons={false}
        />
        <EditNumber
          title={'מספר דירה (אופציונלי)'}
          onChange={(value: number) => setFlatNumber(value.toString())}
          showButtons={false}
        />
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            marginBottom: '16px',
          }}
        >
          <label style={{ fontSize: '14px', color: '#4b5563' }}>
            עיר מגורים (אופציונלי)
          </label>
          <AutoComplete
            value={selectedCity}
            suggestions={filteredCities}
            completeMethod={searchCities}
            onChange={(e) => setSelectedCity(e.value)}
            onSelect={handleSelect}
            placeholder="חפש עיר..."
            loading={loading2}
            dropdown={false}
            aria-label="Cities"
            inputStyle={{
              width: '100%',
              height: '36px',
              boxSizing: 'border-box',
            }}
            style={{
              width: '100%',
              position: 'static',
              display: 'block',
              left: 0,
              right: 0,
            }}
          />
        </div>
        <EditNumber
          title={'מיקוד (אופציונלי)'}
          onChange={(value: number) => setPostCode(value.toString())}
          max={99999999}
          showButtons={false}
          maxLength={9}
        />
        <div
          style={{
            flex: '1', // Flex-grow, flex-shrink, and base size of 250px
            minWidth: '250px', // Ensure a minimum width of 250px

            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label
            style={{ fontSize: '14px', color: '#4b5563', marginBottom: '8px' }}
          >
            טלפון נייד
          </label>

          <div style={{ direction: 'rtl' }}>
            <EditText
              value={phoneNumber}
              onChange={(value: string) => updatePhoneNumber(value)}
            />
          </div>
        </div>

        <div
          style={{
            flex: '1', // Flex-grow, flex-shrink, and base size of 250px
            minWidth: '250px', // Ensure a minimum width of 250px

            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label
            style={{ fontSize: '14px', color: '#4b5563', marginBottom: '8px' }}
          >
            טלפון נייד נוסף (אופציונלי)
          </label>

          <div style={{ direction: 'rtl' }}>
            <EditText
              value={additionalPhoneNumber}
              onChange={(value: string) => updateAdditionalPhoneNumber(value)}
            />
          </div>
        </div>

        <div
          style={{
            flex: '1', // Flex-grow, flex-shrink, and base size of 250px
            minWidth: '250px', // Ensure a minimum width of 250px
            marginBottom: '16px', // Optional bottom margin for row spacing
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label style={{ fontSize: '14px', color: '#4b5563' }}>
            תאריך לידה
          </label>

          <Calendar
            id="buttondisplay"
            style={{
              height: '36px',
              direction: 'ltr',
              marginTop: '8px',
            }}
            value={date}
            inputStyle={{ textAlign: 'right' }}
            dateFormat={'dd/mm/yy'}
            onChange={handleDateChange}
            showIcon={true}
            iconPos={'right'}
            yearNavigator={true}
            yearRange={'1900:2024'}
          />
        </div>
        <EditText title={'דוא״ל'} onChange={setMail} />

        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            marginBottom: '16px',
          }}
        >
          <label style={{ fontSize: '14px', color: '#4b5563' }}>
            ארץ עליה (אופציונלי)
          </label>
          <AutoComplete
            value={selectedCountry}
            suggestions={filteredCountries}
            completeMethod={searchCountries}
            onChange={(e) => setSelectedCountry(e.value)}
            onSelect={handleSelect}
            placeholder="חפש מדינה..."
            loading={loading2}
            dropdown={false}
            aria-label="Countries"
            inputStyle={{
              width: '100%',
              height: '36px',
              boxSizing: 'border-box',
            }}
            style={{
              width: '100%',
              position: 'static',
              display: 'block',
              left: 0,
              right: 0,
            }}
          />
        </div>

        <div
          style={{
            flex: '1', // Flex-grow, flex-shrink, and base size of 250px
            minWidth: '250px', // Ensure a minimum width of 250px
            marginBottom: '16px', // Optional bottom margin for row spacing
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label style={{ fontSize: '14px', color: '#4b5563' }}>
            תאריך עליה (אופציונלי)
          </label>

          <Calendar
            id="buttondisplay"
            style={{
              height: '36px',
              direction: 'ltr',
              marginTop: '8px',
            }}
            inputStyle={{ textAlign: 'right' }}
            dateFormat={'dd/mm/yy'}
            value={immigrationDate}
            onChange={handleImmigrationDateDateChange}
            showIcon={true}
            iconPos={'right'}
            yearNavigator={true}
            yearRange={'1900:2024'}
          />
        </div>

        <div
          style={{
            flex: '1',
            minWidth: '250px',
            marginBottom: '16px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label style={{ fontSize: '14px', color: '#4b5563' }}>מגדר</label>
          <Dropdown
            value={selectedGender}
            style={{
              height: '35px',
              display: 'flex',
              alignItems: 'center',
              marginTop: '8px',
            }}
            options={genderOptions}
            onChange={onGenderChange}
            placeholder="בחר מגדר"
            className="w-full md:w-14rem"
          />
        </div>

        <div
          style={{
            flex: '1',
            minWidth: '250px',
            marginBottom: '16px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label style={{ fontSize: '14px', color: '#4b5563' }}>
            מצב משפחתי (אופציונלי)
          </label>
          <Dropdown
            value={selectedMartialStatus}
            style={{
              height: '35px',
              display: 'flex',
              alignItems: 'center',
              marginTop: '8px',
            }}
            options={martialStatusOptions}
            onChange={onMartialStatusChange}
            placeholder="בחר סטטוס"
            className="w-full md:w-14rem"
          />
        </div>

        {userType === UserType.STUDENT && (
          <div
            style={{
              flex: '1',
              minWidth: '250px',
              marginBottom: '16px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <label style={{ fontSize: '14px', color: '#4b5563' }}>שלוחות</label>
            <MultiSelect
              value={selectedBranchIds}
              style={{
                minHeight: '35px',
                display: 'flex',
                alignItems: 'center',
                marginTop: '8px',
              }}
              options={globalSettingsBranches.branches}
              optionLabel="branchName"
              optionValue="id"
              onChange={(e) => setSelectedBranchIds(e.value)}
              placeholder="בחר שלוחות"
              className="w-full md:w-14rem"
              display="chip"
            />
          </div>
        )}
      </div>

      {userType === undefined && (
        <div>
          <label
            style={{ fontSize: '14px', color: '#4b5563', marginBottom: '8px' }}
          >
            סוג משתמש
          </label>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: '8px',
            }}
          >
            <AddUserDialogSelectUserType
              text={'סטודנט'}
              checked={userType === UserType.STUDENT}
              onChange={(checked: boolean) => {
                checked && setUserType(UserType.STUDENT);
              }}
            />
            <AddUserDialogSelectUserType
              text={'מרצה'}
              checked={userType === UserType.LECTURER}
              onChange={(checked: boolean) => {
                checked && setUserType(UserType.LECTURER);
              }}
            />
            <AddUserDialogSelectUserType
              text={'מנהלה'}
              checked={userType === UserType.ADMINISTRATION}
              onChange={(checked: boolean) => {
                checked && setUserType(UserType.ADMINISTRATION);
              }}
            />
          </div>
        </div>
      )}
      <div style={{ marginTop: '24px' }} />

      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{ height: '30px', width: '100%' }}
          label={'אישור'}
          loading={loading}
          onClick={handleOnSubmit}
        />
      </div>
    </div>
  );
};
